import { appI18n } from '@flowus/common/i18n';
import { AIEditType, isAiMindMap } from './const';

/** 目前仅生成思维导图类型需要修复一下prompt */
export const fixPrompt = (prompt: string, aiEditType: AIEditType) => {
  if (isAiMindMap.has(aiEditType)) {
    return __BUILD_IN__
      ? `${prompt},Return the data in outline form, the first line needs a title, remove non-outline content, no need for a conclusion at the end, return in the format of """# "$\{HEADING1}"\n ## "$\{HEADING2}"\n ### "$\{HEADING3}"\n #### "$\{HEADING4}"\n """  `
      : `${prompt},${appI18n.t('components.ai_editor.fix_prompt_mindmap')}`;
  }
  return prompt;
};
